import configureAxios from 'configure/axios';

const axios = configureAxios();

export const arrangePurchase = (id, attrs) =>
  axios.post(`purchases/${id}/payment_arrangement/`, attrs);